import { BoxProps, TextProps } from '@jfs/ui-new'

const styles = {
  closeIcon: {
    alignSelf: 'flex-end',
  } as BoxProps,
  initiateRefundBox: {
    bg: 'BLUE',
    borderRadius: 8,
    justify: 'center',
    paddingVertical: 15,
    mt: 15,
    align: 'center',
    underlayColor: 'WHITE',
  } as BoxProps,
  boxWrapper: (keyboardHeight: number, statusBarHeight: number, isIos: boolean) => ({
    backgroundColor: 'white',
    marginBottom: isIos ? (statusBarHeight > 30 ? keyboardHeight - statusBarHeight : keyboardHeight) : 0,
    borderTopLeftRadius: 14,
    borderTopRightRadius: 14,
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 40,
  }),
  errorText: {
    fontSize: 12,
    color: 'ERROR',
  } as TextProps,
  leftRupeeText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'BLACK',
  } as TextProps,
}

export default styles
